import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=69ffeb34&"
import script from "./TabHeader.vue?vue&type=script&lang=js&"
export * from "./TabHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports